import React, { useEffect, useState } from 'react';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';

const C = {
  purple: '#7c3aed', purpleDark: '#5b21b6', ink: '#1e1b2e', gray: '#6b7280',
  bg: '#faf9fc', card: '#ffffff', line: '#ece9f5',
};

export default function EnAccion() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);
  const [form, setForm] = useState({ nombre: '', telefono: '', barrio: '', texto: '', website: '' });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(null); // { ok, mensaje } | { ok:false, error }

  useEffect(() => {
    document.title = 'Federico Chouhy · En acción';
    fetch(`${API_BASE}/public/en-accion`).then((r) => r.json()).then(setData).catch(() => setErr(true));
  }, []);

  async function enviarReclamo(e) {
    e.preventDefault();
    if (form.texto.trim().length < 8) { setSent({ ok: false, error: 'Contanos un poco más tu reclamo.' }); return; }
    setSending(true); setSent(null);
    try {
      const r = await fetch(`${API_BASE}/public/reclamo`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const j = await r.json();
      if (r.ok && j.ok) { setSent({ ok: true, mensaje: j.mensaje || '¡Recibido! Gracias por avisar.' }); setForm({ nombre: '', telefono: '', barrio: '', texto: '', website: '' }); }
      else setSent({ ok: false, error: j.error || 'No pudimos enviar tu reclamo.' });
    } catch { setSent({ ok: false, error: 'No pudimos enviar tu reclamo. Probá más tarde.' }); }
    finally { setSending(false); }
  }

  if (err) return <div style={{ padding: 40, fontFamily: 'system-ui' }}>No se pudo cargar.</div>;
  if (!data) return <div style={{ padding: 40, fontFamily: 'system-ui', color: C.gray }}>Cargando…</div>;

  const { candidato, gestion, labor } = data;
  const wrap = { fontFamily: "system-ui,-apple-system,'Segoe UI',Roboto,sans-serif", background: C.bg, color: C.ink, minHeight: '100vh' };
  const container = { maxWidth: 980, margin: '0 auto', padding: '0 20px' };
  const card = { background: C.card, border: `1px solid ${C.line}`, borderRadius: 14, padding: '1.2rem 1.4rem' };

  const input = { width: '100%', padding: '0.6rem 0.7rem', border: `1px solid ${C.line}`, borderRadius: 8, fontSize: 14, fontFamily: 'inherit', boxSizing: 'border-box' };

  return (
    <div style={wrap}>
      {/* Hero */}
      <div style={{ background: `linear-gradient(135deg,${C.purpleDark},${C.purple})`, color: '#fff', padding: '3rem 0 2.4rem' }}>
        <div style={{ ...container, display: 'flex', gap: 28, alignItems: 'center', flexWrap: 'wrap' }}>
          <img src={candidato.foto} alt={candidato.nombre} style={{ width: 150, height: 190, objectFit: 'cover', borderRadius: 12, border: '3px solid rgba(255,255,255,.35)' }} onError={(e) => { e.currentTarget.style.display = 'none'; }} />
          <div style={{ flex: 1, minWidth: 260 }}>
            <div style={{ textTransform: 'uppercase', letterSpacing: '.15em', fontSize: 12, opacity: .85 }}>{candidato.mandato}</div>
            <h1 style={{ margin: '.3rem 0', fontSize: '2.4rem', lineHeight: 1.1 }}>{candidato.nombre}</h1>
            <div style={{ fontSize: 15, opacity: .92 }}>{candidato.cargo}</div>
            <p style={{ marginTop: 14, maxWidth: '60ch', lineHeight: 1.6, opacity: .95 }}>{candidato.bio}</p>
          </div>
        </div>
      </div>

      {/* Stats */}
      <div style={{ ...container, marginTop: -34 }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(160px,1fr))', gap: 14 }}>
          {[
            { n: gestion.resueltos, l: 'Reclamos resueltos' },
            { n: gestion.barrios, l: 'Barrios con gestión' },
            { n: labor.aprobados, l: 'Proyectos aprobados' },
            { n: labor.presentados, l: 'Proyectos presentados' },
          ].map((s, i) => (
            <div key={i} style={{ ...card, textAlign: 'center' }}>
              <div style={{ fontSize: '2.1rem', fontWeight: 800, color: C.purple }}>{s.n}</div>
              <div style={{ fontSize: 13, color: C.gray, marginTop: 4 }}>{s.l}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Gestión */}
      <div style={{ ...container, marginTop: 34, paddingBottom: 50 }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 18, alignItems: 'start' }}>
          <section>
            <h2 style={{ fontSize: '1.3rem' }}>Gestión resuelta</h2>
            {gestion.recientes.length === 0 && <p style={{ color: C.gray }}>Muy pronto, los primeros resultados de gestión.</p>}
            {gestion.recientes.map((r, i) => (
              <div key={i} style={{ ...card, marginBottom: 10 }}>
                <div style={{ fontWeight: 600 }}>✅ {r.titulo}</div>
                {r.barrio && <div style={{ fontSize: 13, color: C.gray }}>📍 {r.barrio}</div>}
              </div>
            ))}
          </section>
          <section>
            <h2 style={{ fontSize: '1.3rem' }}>Labor en el Concejo</h2>
            {labor.items.length === 0 && <p style={{ color: C.gray }}>Próximamente, los proyectos presentados.</p>}
            {labor.items.map((l, i) => (
              <div key={i} style={{ ...card, marginBottom: 10 }}>
                <div style={{ fontWeight: 600 }}>{l.titulo}</div>
                <div style={{ fontSize: 12, color: C.purple, textTransform: 'uppercase', letterSpacing: '.05em' }}>{String(l.tipo).replace('_', ' ')} · {String(l.estado).replace('_', ' ')}</div>
              </div>
            ))}
          </section>
        </div>
      </div>

      {/* Reclamo del vecino */}
      <div style={{ background: '#fff', borderTop: `1px solid ${C.line}` }}>
        <div style={{ ...container, padding: '40px 20px' }}>
          <h2 style={{ fontSize: '1.4rem', marginTop: 0 }}>Contanos tu problema del barrio</h2>
          <p style={{ color: C.gray, marginTop: 4, maxWidth: '60ch' }}>
            Un bache, una luminaria, un tema de seguridad. Lo tomamos y lo gestionamos.
          </p>
          {sent && sent.ok ? (
            <div style={{ ...card, borderColor: C.purple, color: C.purpleDark, maxWidth: 620 }}>✅ {sent.mensaje}</div>
          ) : (
            <form onSubmit={enviarReclamo} style={{ maxWidth: 620, display: 'grid', gap: 10 }}>
              {/* honeypot anti-bot: oculto para humanos */}
              <input type="text" name="website" value={form.website} onChange={(e) => setForm({ ...form, website: e.target.value })}
                tabIndex={-1} autoComplete="off" style={{ position: 'absolute', left: '-9999px', width: 1, height: 1 }} aria-hidden="true" />
              <textarea placeholder="Contanos qué pasa y dónde…" value={form.texto} onChange={(e) => setForm({ ...form, texto: e.target.value })}
                rows={4} style={{ ...input, resize: 'vertical' }} required />
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(150px,1fr))', gap: 10 }}>
                <input placeholder="Tu nombre (opcional)" value={form.nombre} onChange={(e) => setForm({ ...form, nombre: e.target.value })} style={input} />
                <input placeholder="Barrio (opcional)" value={form.barrio} onChange={(e) => setForm({ ...form, barrio: e.target.value })} style={input} />
                <input placeholder="WhatsApp (opcional)" value={form.telefono} onChange={(e) => setForm({ ...form, telefono: e.target.value })} style={input} />
              </div>
              {sent && !sent.ok && <div style={{ color: '#b91c1c', fontSize: 14 }}>{sent.error}</div>}
              <div>
                <button type="submit" disabled={sending}
                  style={{ background: C.purple, color: '#fff', border: 'none', borderRadius: 8, padding: '0.7rem 1.4rem', fontSize: 15, fontWeight: 600, cursor: sending ? 'default' : 'pointer', opacity: sending ? 0.7 : 1 }}>
                  {sending ? 'Enviando…' : 'Enviar reclamo'}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>

      <footer style={{ borderTop: `1px solid ${C.line}`, padding: '20px', textAlign: 'center', color: C.gray, fontSize: 13 }}>
        Federico Chouhy · San Nicolás de los Arroyos
      </footer>
    </div>
  );
}
